const deviceTypeFromUserAgent = (userAgent = '') => {
  if (typeof userAgent !== 'string') return 'desktop';

  const isMobileRegEx = /(Mobile|iP(hone|od)|BlackBerry|IEMobile|Kindle|NetFront|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dol(f|ph)in|Skyfire|Zune)/g;
  return isMobileRegEx.test(userAgent) ? 'mobile' : 'desktop';
};

export default deviceTypeFromUserAgent;
